import { Dialog, MenuItem, Select, styled } from '@mui/material';
import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'grid',
            positon: 'relative',
            minHeight: '100%',
            maxHeight: '100%',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            gridTemplateColumns: 'minmax(0px, 1fr)',
            gridTemplateAreas: '"header" "content"',
            rowGap: '1px',
            background: theme.palette.background.paper
        }
    }
})

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export const StyledSelect = styled(Select)(({theme}) => ({
    width: '80px',
    '& .MuiInputBase-input': { padding: '10px' },
    fontSize: '12px',
    '& .MuiSelect-select': {
        fontSize: '12px',
        padding: '4px 20px 3px 7px !important',
    },
    '& .MuiSelect-icon': {
        fontSize: '16px'
    },
    '& .Mui-disabled': {
        color: `${theme.palette.text.primary} !important`,
        '-webkit-text-fill-color': `${theme.palette.text.primary} !important`,
        textAlign: 'center'
    },
    '&.Mui-disabled': {
        opacity: 1,
        width: 'auto !important',
        '& svg': {
            display: 'none'
        }
    }
}))

export const TextOnlySelect = styled(Select)(({theme})=>({
    fontSize: '10px',
    width: '100px',
    '& .MuiInputBase-input': { padding: '10px' },
    '&.MuiOutlinedInput-root': {
        border: 'none',
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
        },
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },
    background: 'none',
    padding: 0,
    color: theme.palette.text.secondary,
    '& .MuiSelect-select': {
        padding: 0,
        fontSize: '10px',
        paddingRight: '15px !important'
    },
    '& .MuiSelect-icon': {
        fontSize: '14px'
    }
}))

export const StyledMenuItem = styled(MenuItem)(()=>({
    fontSize: '12px',
    padding: '6px 10px'
}))